import * as React from 'react';
import 'isomorphic-fetch';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { convertToRaw, ContentState, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
export class Content extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contentResult: null,
            languagesResult: null,
            loading: true,
            processing: false,
            mouseOver: false,
            editing: false,
            currentEditingLanguageId: -1,
            currentEditingText: null,
            initialEditingText: null,
            editorState: null,
        };
        fetch('Data/GetContent/' + this.props.contentId + '/' + this.props.languageId, { credentials: 'same-origin' })
            .then(response => response.json())
            .then(data => {
            var newState = this.copyState();
            newState.contentResult = data;
            newState.loading = false;
            this.setState(newState);
        });
    }
    render() {
        let contents = React.createElement("div", null);
        if (this.state.loading) {
            contents = React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.initialText } });
        }
        else if (this.state.processing) {
            contents = React.createElement("div", null, "Processing...");
        }
        else {
            if (this.state.editing) {
                let currentInput = React.createElement("div", null);
                if (this.state.currentEditingLanguageId != -1) {
                    currentInput = React.createElement("div", null,
                        React.createElement(Editor, { editorState: this.state.editorState, toolbarClassName: "toolbarClassName", wrapperClassName: "wrapperClassName", editorClassName: "editorClassName", onEditorStateChange: (editorState) => { this.onEditorStateChange(editorState); } }));
                }
                else {
                    currentInput = React.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.contentResult.content } });
                }
                let saveButton = React.createElement("div", null);
                if (this.state.currentEditingText != this.state.initialEditingText) {
                    saveButton = React.createElement("div", null,
                        React.createElement("button", { className: "btn btn-primary", onClick: () => { this.handleSaveClick(); } }, "Save"));
                }
                contents = React.createElement("div", null,
                    React.createElement("button", { className: "btn btn-primary", onClick: () => { this.handleCloseClick(); } }, "Close"),
                    React.createElement("br", null),
                    this.state.languagesResult.languages.map(language => {
                        if (this.state.currentEditingLanguageId == language.id) {
                            return React.createElement("button", { className: "btn btn-primary", disabled: true }, language.code);
                        }
                        return React.createElement("button", { className: "btn btn-primary", onClick: () => { this.onLanguageClick(language.id); } }, language.code);
                    }),
                    currentInput,
                    saveButton);
            }
            else if (this.state.mouseOver) {
                contents = React.createElement("div", null,
                    React.createElement("button", { className: "btn btn-primary", onClick: () => { this.handleEditClick(); } }, "Edit"),
                    React.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.contentResult.content } }));
            }
            else {
                contents = React.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.contentResult.content } });
            }
        }
        return React.createElement("div", { onMouseEnter: () => { this.handleMouseOver(); }, onMouseLeave: () => { this.handleMouseOut(); } }, contents);
    }
    onEditorStateChange(editorState) {
        var newState = this.copyState();
        newState.editorState = editorState;
        if (this.state.editorState != null) {
            var content = this.state.editorState.getCurrentContent();
            var rawContent = convertToRaw(content);
            var htmlContent = draftToHtml(rawContent);
            newState.currentEditingText = htmlContent;
        }
        this.setState(newState);
    }
    copyState() {
        return {
            contentResult: this.state.contentResult,
            languagesResult: this.state.languagesResult,
            loading: this.state.loading,
            processing: this.state.processing,
            mouseOver: this.state.mouseOver,
            editing: this.state.editing,
            currentEditingText: this.state.currentEditingText,
            initialEditingText: this.state.initialEditingText,
            currentEditingLanguageId: this.state.currentEditingLanguageId,
            editorState: this.state.editorState
        };
    }
    onContentChanged(newValue) {
        var newState = this.copyState();
        newState.currentEditingText = newValue;
        this.setState(newState);
    }
    onLanguageClick(languageId) {
        var newState = this.copyState();
        newState.currentEditingLanguageId = languageId;
        newState.processing = true;
        this.setState(newState);
        fetch('Data/GetContent/' + this.props.contentId + '/' + languageId, { credentials: 'same-origin' })
            .then(response => response.json())
            .then(data => {
            var newState = this.copyState();
            newState.processing = false;
            newState.currentEditingText = data.content;
            newState.initialEditingText = data.content;
            var blocksFromHtml = htmlToDraft(data.content);
            var contentState = ContentState.createFromBlockArray(blocksFromHtml.contentBlocks, blocksFromHtml.entityMap);
            var editorState = EditorState.createWithContent(contentState);
            newState.editorState = editorState;
            this.setState(newState);
        });
    }
    handleSaveClick() {
        {
            var newState = this.copyState();
            newState.processing = true;
            this.setState(newState);
        }
        var updateContentData = new UpdateContentData();
        updateContentData.contentId = this.props.contentId;
        updateContentData.newData = this.state.currentEditingText;
        updateContentData.languageId = this.state.currentEditingLanguageId;
        fetch('Data/UpdateContent', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(updateContentData)
        })
            .then(response => response.json())
            .then(result => {
            if (result.successful) {
                var newState = this.copyState();
                newState.processing = false;
                newState.initialEditingText = newState.currentEditingText;
                this.setState(newState);
            }
            else {
                var newState = this.copyState();
                newState.processing = false;
                this.setState(newState);
            }
        });
    }
    handleEditClick() {
        {
            var newState = this.copyState();
            newState.processing = true;
            this.setState(newState);
        }
        fetch('Data/GetLanguages', { credentials: 'same-origin' })
            .then(response => response.json())
            .then(data => {
            var newState = this.copyState();
            newState.languagesResult = data;
            newState.processing = false;
            newState.editing = true;
            this.setState(newState);
        });
    }
    handleCloseClick() {
        {
            var newState = this.copyState();
            newState.editing = false;
            newState.currentEditingLanguageId = -1;
            newState.currentEditingText = null;
            newState.initialEditingText = null;
            newState.processing = true;
            newState.editorState = null;
            this.setState(newState);
        }
        fetch('Data/GetContent/' + this.props.contentId + '/' + this.props.languageId, { credentials: 'same-origin' })
            .then(response => response.json())
            .then(data => {
            var newState = this.copyState();
            newState.processing = false;
            newState.contentResult = data;
            this.setState(newState);
        });
    }
    handleMouseOver() {
        var newState = this.copyState();
        newState.mouseOver = true;
        this.setState(newState);
    }
    handleMouseOut() {
        var newState = this.copyState();
        newState.mouseOver = false;
        this.setState(newState);
    }
}
class UpdateContentData {
}
//# sourceMappingURL=Content.js.map


//////////////////
// WEBPACK FOOTER
// ./ClientApp/Content.js
// module id = 46
// module chunks = 0